const scheduledServicesEventCardList = {
  servicesTitle: 'Servicios',
  servicesFilters: 'Filtros Servicios',
  showMoreButton: 'Mostrar más',
  notFound: 'Sin servicios encontrados',
  assignMany: 'Asignar múltiplos',
  assignOne: 'Asignar uno',
  selectAll: 'Seleccionar todo',
  clearAll: 'Limpiar todo',
};

export default scheduledServicesEventCardList;
